import * as React from 'react';
import {Link, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {createClientShare} from "../../../api";


const ShareFile: React.FunctionComponent = () => {
    const {clientId} = useParams();
    const [shareId, setShareId] = useState();

    useEffect(() => {
        createClientShare(clientId)
            .then((s) => {
                setShareId(s.uuid);
            })
    }, []);

    return ((shareId === undefined) ? <>...Loading...</>
        : <>
            <div className={"col-lg-12 mb-3 "}>
                <h3>Share Client File</h3>
                <p>The following share link was generated for this client file. It is valid for 24 hours.</p>
                <p>
                    <a href={"https://promises12data.com/m/share/" + clientId + "?key=" + shareId} target={"_blank"}>{"https://promises12data.com/m/share/" + clientId + "?key=" + shareId}</a>
                </p>
            </div>
            <div className={"col-lg-12 mb-3 "}>
                <Link to={"/m/clients/view/" + clientId}>

                    <button type={"submit"} className={"btn btn-danger mr-3"}>Back</button>
                </Link>
            </div>
        </>);
};

export default ShareFile;